import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useAppLayoutContextConsumer } from '@occc-app/design-system';
import { useGetCampaignName, getCreatePageLinks } from '@occc-app/routes/CampaignComponents/utils';
import { Offer_Engagement_Type } from '@occc/graphql';
import { OfferType } from '@occc-app/offerValidationService/types';
import { CampaignComponentTabs } from '@occc-app/routes/CampaignComponents/components/ConfigurationLayout';

import { useChainId } from '@occc-app/Chain/hooks';
import { useNavigateToCampaign } from '@occc-app/offerHelpers/hooks/useNavigateToCampaign';

import { OfferCreateConfigurePage } from '@occc-app/routes/Offer/OfferCreatePage/OfferCreateConfigurePage';
import { Flow_Types } from '@occc-app/offerHelpers/types';
import { ConfigureForm } from '../components/BillboardConfigureForm/ConfigureForm';
import { getConfigureFormOperations } from '../components/BillboardConfigureForm/utils/configureFormOperations';
import { messages } from '../messages';
import { routeCreator } from '../utils';
import { ConfigureFormInitialValues, ConfigureFormValues } from '../types';

export const BillboardCreatePageContainer = () => {
  const navigate = useNavigate();
  const { id: campaignId = '' } = useParams<{ id: string }>();

  const chainId = useChainId();
  const campaignName = useGetCampaignName(chainId, campaignId);
  const navigateToCampaign = useNavigateToCampaign(campaignId);

  const links = useMemo(
    () => getCreatePageLinks(campaignId, campaignName, 'New Billboard'),
    [campaignId, campaignName],
  );
  useAppLayoutContextConsumer(links);

  return (
    <OfferCreateConfigurePage<ConfigureFormValues, ConfigureFormInitialValues>
      pageTitle='Campaign > Create'
      subtitle={messages.subtitle}
      offerType={OfferType.Billboard}
      engagementType={Offer_Engagement_Type.Billboard}
      campaignId={campaignId}
      getConfigureOperations={getConfigureFormOperations}
      getInitialValues={() => ({})}
      onOfferCreated={(offerId) =>
        navigate(routeCreator.configureWithTab(campaignId, offerId, CampaignComponentTabs.Target))
      }
      renderConfigureForm={({ onSubmit, initialValues, loading }) => (
        <ConfigureForm
          onSubmit={onSubmit}
          initialValues={initialValues}
          loading={loading}
          onCancelClick={navigateToCampaign}
          currentFlowType={Flow_Types.Configure}
          isFormEditable
        />
      )}
    />
  );
};
